import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const CustomerTestimonials = () => {
  const TestimonialsContent = [
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjVAFvZ7T7qOiJwJT8Xi47s8s2PJRqVho25AQdauOjyeWbyVRXWfDA=w60-h60-p-rp-mo-ba4-br100",
      userCompany: "/assests/images/logo-new.jpg",
      userName: "Rallabandi Karthik",
      userDesgination: "",
      userFrom: "Accelalpha",
      userTestimonial:
        "Eyantra has been an excellent vendor for us, providing welcome kits, Diwali gifts, and event giveaways. Their commitment to on-time delivery, exceptional product quality, and reliable service has always been impressive. A truly professional and dependable team to work with. Highly recommended!",
    },
    {
      userImg:
        "https://lh3.googleusercontent.com/a/ACg8ocKiPIS8mHsZnaxtC4ArokA3OvVABkhwZDgS_B2BSYYID2jaOA=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/3f-oil.png",
      userName: "Jagadeswar Reddy",
      userDesgination: "",
      userFrom: "3F oil",
      userTestimonial:
        "Our company recently worked with eYantra for customized corporate gifts, and we were highly impressed. The product quality, branding, and timely delivery exceeded our expectations. Leela and the team ensured a hassle-free experience, and we look forward to future collaborations",
    },
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/h_logo.png",
      userName: "Alankrit Shinghal",
      userDesgination: "",
      userFrom: "Hyundai Mobis",
      userTestimonial: (
        <>
          <p>
            Whenever I am thinking about our stakeholders gifting, eYantra is
            the first name that comes into my mind. They made our quarterly
            trophies elegant.
          </p>
          <p>We really like their follow-ups and timely delivery.</p>
        </>
      ),
    },
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/Alivecor.svg",
      userName: "Sagarika Bai",
      userDesgination: "",
      userFrom: "Alivecor",
      userTestimonial: (
        <p>
          I interacted with Sanjeet to help with Branded laptop bags for our
          company Alivecor in a short span and he and team gave us timely
          delivery and quality products. Thanks eYantra Team and special thanks
          to Sanjeet for the support.
        </p>
      ),
    },
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/teksystems.svg",
      userName: "Jinesh r nair",
      userDesgination: "",
      userFrom: "TEK systems",
      userTestimonial: (
        <p>
          Thank you Sundeep and team from E-Yantra for providing us an
          enriching experience for our company Diwali Gifting. Looking forward
          to work with you on more occasions coming our way.
        </p>
      ),
    },
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/cotiviti.png",
      userName: "Shashi Bonagiri",
      userDesgination: "",
      userFrom: "Cotiviti",
      userTestimonial: (
        <p>
          Whenever I am thinking about our stakeholders gifting, eYantra is the
          first name that comes into my mind. They made our quarterly trophies
          elegant. We really like their follow-ups and timely delivery.
        </p>
      ),
    },
  ];

  return (
    <div className="container-fluid bgeYantra">
      <Container className="pt-5 pb-5">
        <h2 id="subHeading">Customer Testimonials</h2>
        <Swiper
          spaceBetween={30}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={true}
          loop={true}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {TestimonialsContent.map((item, index) => (
            <SwiperSlide key={index}>
            <div className="testimonials h-100 rounded p-3 d-flex flex-column justify-content-center">
          
                <div className="d-flex justify-content-between align-items-center mb-3 h-100">
                  <div className="d-flex flex-column">
                    <p className="textSecondary fs-medium fw-bold mb-1">
                      {item.userName}
                    </p>
                    <span className="textGray fs-14">{item.userDesgination}</span>
                  </div>
                  <div>
                    <img
                      src={item.userCompany}
                      alt="Company Logo"
                      width="60"
                      className="d-block m-auto"
                      loading="lazy"
                    />
                    <p className="fs-12 text-center mt-1">
                      From: <b>{item.userFrom}</b>
                    </p>
                  </div>
                </div>
                <div className="border-top pt-3 fs-14">{item.userTestimonial}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </div>
  );
};

export default CustomerTestimonials;
